import React, { useState, useEffect, Children } from "react";
import { EmployeeDataVM, EmployeeRecordsVM, EmployeeTeamVM, PKTVM } from '../../Models/ViewModels';
import { Table, Pagination, Stack, Avatar, Input, Button, DatePicker, InputGroup } from "rsuite";
import * as ProfileDB from '../../Services/KRAApprovalDB';
import { PageHeader } from "../../SharedComponents/PageHeader";

import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from '../../SharedComponents/CustomTableCell';
import { CustomTableHeaderCell } from '../../SharedComponents/CustomTableHeaderCell';
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { GetEmployeeIdInfo, GetEmployeeRecords, GetLocationDetails, GetTeamInfo } from "../../Services/EmployeeDB";
import {
  Dropdown,
  DropdownButton,
  Form,
  Modal,
} from "react-bootstrap";
// import { stripBasename } from "react-router/lib/router";
const { Column, HeaderCell, Cell } = Table;
const colors = ['pink', 'grey', 'blue', 'yellow', 'purple', 'green', 'red'];

export const ManageEmployeeApplication = ({ name, designation, department }: any) => {

  const [cachedEmployeesList, setCachedEmployeesList] = useState(new Array<PKTVM>())
  const [isLoading, setLoading] = useState(true)
  const [page, setPage] = React.useState(1);
  const [date, setDate] = useState();
  const  [all,setAll]=useState([])
  const [employee, setEmployee] = useState();
  const [cachedTeamList, setCachedTeamList] = useState(new Array<EmployeeTeamVM>());
  const [searchby, setSearchBy] = useState("Dropdown");
  const [eName, setName] = useState(false)
  const [app, setApp] = useState(false)

  const [limit, setLimit] = React.useState(15);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(new Array<EmployeeRecordsVM>());
  const[loginid,setLoginid]=useState(GetUserLoginID())
  const[searching,setSearching]=useState(false);
  const ids:any=[]
  const names:any=[]
  useEffect(() => {
    getAllEmployeesPKT(loginid);
  },[])


const handleSet=(value:any)=>{
   alert("Button Clicked")
}

  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start =limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getAllEmployeesPKT = (loginid:any) => {
  GetLocationDetails(loginid).then((res : EmployeeTeamVM[] | any) => {
      if (res.data) {
        setCachedEmployeesList(res.data)
        setLoading(false);
        GetEmployeeIdInfo(loginid).then(res => {
      
          if (res.data) {   
            for (let i = 0; i < res.data.info.length; i++)
            {
               ids.push(res.data.info[i].id)
            }             
            for (let i = 0; i < res.data.info.length; i++)
            {

               names.push(res.data.info[i].name)
            }
            setAll(res.data.info)
          
     
    }}).catch(err => {
      console.log(err)
    })
   
      };
    }).catch(err => {
      console.log("fail")
    })
  }
  const SearchBy = (value: any) => {
    setSearchBy(value);
    if(value=='App')
    {
    setApp(true)
    setName(false)
    }
    else if(value=='Name')
   { setName(true)
    setApp(false)
   }
  };
  const GetEmployeeDetail=(id:any)=>{
    GetEmployeeRecords(id).then(res => {
      if (res.data) {
        console.log(res.data)
        setFilteredEmployeesList(res.data);
        GetTeamInfo(id).then(res => {
          if (res.data) {
            setCachedTeamList(res.data);
          }
    
        }).catch(err => {
          console.log(err)
        })
      }

    }).catch(err => {
      console.log(err)
    })
        
  }



  const handleChange=(e:any)=>{
    
    // setEmployee()
    GetEmployeeDetail(e.target.value)

  }

  return <>
   
  <div className="row">
  <div className="col-md-7s">
  <PageHeader title="Manage User Applications" backPage="" ><></></PageHeader>
    </div>
   
                  <DropdownButton
                  className="mb-3"
                    variant="outline-secondary"
                    title={searchby}
                    id="input-group-dropdown-1"
                  >
                    <Dropdown.Item href="#"onClick={() => SearchBy("App")} >
                      App
                    </Dropdown.Item>
                    <Dropdown.Item href="#"onClick={() => SearchBy("Name")} >
                      Name
                    </Dropdown.Item></DropdownButton> 
                    {eName?<div className="col-md-2"> Search for Users: <select id="select"   name="EmployeeOfficeBadgeId" onChange={handleChange} >   
           <option>SELECT EMPLOYEE NAME</option>
              {
            
       all.map((all:any)=>{
  
       if(all===null)
       return<></>
       else
       return(
          <option value={all.EmployeeOfficeBadgeId}>{all.FullName}</option>
         
      )
  })
}
         </select>
    </div>:app?<div className="col-md-7"><input type="text"className="col-md-6" placeholder="Enter App name"></input></div>:<></>}
  
    <hr />
</div><br/>
    

    <div className="show-container" bg-color="pink" >
    {
      filteredEmployeesList.length>0?
     <div className="field">
      <h5>Employee Information:</h5><br/>
<div className="row">
  <div className="col-md-3">
        <p>Employee Name : {filteredEmployeesList[0].FullName}</p></div>
        <div className="col-md-2"><p>Employee Id :  {filteredEmployeesList[0].EmployeeOfficeBadgeId}</p></div>
        <div className="col-md-3"><p>Designation :  {filteredEmployeesList[0].EmployeeDesignation}</p></div>
        <div className="col-md-2"><p>Department :  {filteredEmployeesList[0].Department}</p></div>
        {cachedTeamList.length>0?
        <div className="col-md-2"><p>Team :  {cachedTeamList[0].TeamName}</p></div>:<></>}
        <div className="col-md-3"><br/><p>Primary Reporting Officer :  {filteredEmployeesList[0].PrimaryReportingOfficer}</p></div>
        <div className="col-md-3"><br/><p>Secondary Reporting Officer :  {filteredEmployeesList[0].SecondaryReportingOfficer}</p></div>


</div>
     </div>:<></>}<br/>
     {
      filteredEmployeesList.length>0?
     <div>
      <h5>App list for {filteredEmployeesList[0].FullName}</h5>

     
      <Table
        id="table"
        data={tableDataFeed}
        loading={isLoading}
        height={450}
      
        bordered={true}
        cellBordered={true}
        className="border border-dark mt-2"
        autoHeight={true}
        rowHeight={30}
        headerHeight={30}
      >
        


        <Column align="center"flexGrow={230} sortable>
          <CustomTableHeaderCell>
            Applications
          </CustomTableHeaderCell>
          <CustomTableCell dataKey=""  />
        </Column>

        <Column flexGrow={200} align="center"sortable>
          <CustomTableHeaderCell>URL</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>

        <Column flexGrow={180} align="center" >
          <CustomTableHeaderCell>Login Type</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>
        <Column flexGrow={180} align="center" >
          <CustomTableHeaderCell>Created Date</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>
        <Column flexGrow={180} align="center" >
          <CustomTableHeaderCell>Modified Date</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>
        <Column flexGrow  ={180} align="center" >
          <CustomTableHeaderCell>Action</CustomTableHeaderCell>
          <CustomTableCell dataKey=""/>
        </Column>

     </Table></div>:<></>}

        </div>
  </>
}